import { render, staticRenderFns } from "./SetHistory.vue?vue&type=template&id=cfe9844e&scoped=true&"
import script from "./SetHistory.vue?vue&type=script&lang=js&"
export * from "./SetHistory.vue?vue&type=script&lang=js&"
import style0 from "./SetHistory.vue?vue&type=style&index=0&id=cfe9844e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe9844e",
  null
  
)

export default component.exports